<panel width="600">
	<h1>{{ 'company.domains.request-registrar-management.headline' | translate }}</h1>
	<section>
		@if (registrantManagedDomains.length > 0) {
			<h3>{{ 'company.domains.request-registrar-management.select-domains' | translate }}</h3>
			@for (domain of registrantManagedDomains; track domain) {
				<div><label><input type="checkbox" align-right [checked]="isSelected(domain)" (click)="toggleDomain(domain);" /> {{ domain.name }}</label></div>
			}
		}
	</section>
	<section>
		<h3>{{ 'company.domains.request-registrar-management.select-contact' | translate }}</h3>
		<custom-select [required]="true"
					[selectList]="brands"
					[(value)]="brandId"
					[label]="'company.domains.request-registrar-management.choose-brand' | translate"
					[allowAutoFocus]="false" />

		<custom-select [required]="true"
					   [selectList]="contacts"
					   [(value)]="selectedContact"
					   [label]="'company.domains.request-registrar-management.select-contact.label' | translate" />

		<custom-select [required]="true"
					   [selectList]="availableVariants"
					   [(value)]="selectedVariant"
					   [label]="'company.domains.request-registrar-management.select-product-variant.label' | translate" />
	</section>
	<section>
		<button ghost [ignoreValidation]="true" (click)="close()"><icon type="xmark" />{{ 'company.domains.request-registrar-management.reject' | translate }}</button>
		<button confirm [active]="canConfirm()" (click)="confirm()"><icon type="paper-plane" /> {{ 'company.domains.request-registrar-management.confirm' | translate }}</button>
	</section>
</panel>
